<template>
  <span class="radio-index" :class="{'disabled': disabled}" :style="{fontSize: `${size}px`}" @click="onClick">
    <i class="ri-icon el-icon-circle-check" v-if="checked"></i>
    <i class="ri-icon circle-no-check" v-else></i>
    <span class="ri-name" :class="{checked: checked}"><slot></slot></span>
  </span>
</template>
<script>
    export default {
        props:{
            size: Number,
            value: Boolean,
            disabled: Boolean
        },
        data() {
            return {
            };
        },
        computed:{
            checked:{
                get(){
                    return this.value;
                },
                set(v){
                    this.$emit('input', v);
                    this.$emit('onChange', v)
                }
            },
        },
         methods:{
             onClick(){
                 if(this.disabled){
                     return;
                 }
                 let v = this.checked ? false : true;
                 this.$emit('input', v);
                 this.$emit('onChange', v);
             }
         }
    }
</script>
<style lang="scss">
  @import './radio.scss';
</style>